import { VueEditor } from "vue2-editor";
import { NOTIFICATION_FIELDS_LIST } from "../../../../../constants/constants";
import i18n from "../../../../../i18n";

export default {
    name: 'AlertEventDialogNotificationTabComponent',
    components: { VueEditor },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        isValidForm: false,
        title: '',
        titleErrors: [],
        messageBody: '',
        fieldList: [],
        fieldSelected: ''
    }),
    computed: {
    },
    created() {
    },
    mounted() {
        this.fieldList.cleanAndUpdate(NOTIFICATION_FIELDS_LIST.map(field => { return { text: i18n.t(`alertEvent.editDialog.notification.fields.${field}`), value: field } }))
    },
    methods: {
        bodyChanged(){
            this.$emit('update:validForm', !!this.model.title && !!this.model.subject && !!this.model.messageBody);
        },
        validateEmptyRule(value) {
            return !!value && !!value.trim();
        },
        insertField() {
            this.model.messageBody += `##{${this.fieldSelected}}`;
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.isValidForm = !!this.model.title && !!this.model.subject && !!this.model.messageBody;
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.alertEventDialogUserTabForm) {
                this.$refs.alertEventDialogUserTabForm.resetValidation()
            }
        },
        'model.subject': {
            handler: function (newValue) {
                if(newValue === '') {
                    this.isValidForm = false;
                } else {
                    this.isValidForm = true;
                }
            }
        },
        'model.title': {
            handler: function (newValue) {
                if(newValue === '') {
                    this.isValidForm = false;
                } else {
                    this.isValidForm = true;
                }
            }
        },
        'model.messageBody': {
            handler: function (newValue) {
                if(newValue === '') {
                    this.isValidForm = false;
                } else {
                    this.isValidForm = true;
                }
            }
        }
    }
}
